//Done
import React, {useState, useEffect} from 'react';
import {Modal, Form, Input, Select, } from 'antd';

export default function CourseModal ({ gradeDataSource, semesterDataSource, modalIsEditing, visible, record, onCreate, onUpdate, onCancel }) {
    const [gradeSelectDisabled, setGradeSelectDisabled] = useState(false);
    const [semesterSelectDisabled, setSemesterSelectDisabled] = useState(false);
    const [title, setTitle] = useState('');
    const [okText, setOkText] = useState('');

    const {Option} = Select;
    const [form] = Form.useForm();
    
    useEffect(() => {
        form.setFieldsValue({
            grade: (record) ? record.gradeId.grade : '',
            semester: (record) ? record.semesterId.semester : '',
            title: (record) ? record.title : '',
        })
        modalSetting(modalIsEditing)
    }, [form, modalIsEditing, record])

    const modalSetting = (isEditing) => {
        if (isEditing === false) {
            setGradeSelectDisabled(false);
            setSemesterSelectDisabled(false);
            setTitle('Create a new course');
            setOkText('Create');
        } else {
            setGradeSelectDisabled(true);
            setSemesterSelectDisabled(true);
            setTitle('Update a course');
            setOkText('Update');
        }        
    }

    const courseModalCancel = () => {
        onCancel();
        form.resetFields();
    }

    return (
        <Modal
            visible={visible}
            title={title}
            okText={okText}
            cancelText="Cancel"
            onCancel={courseModalCancel}
            onOk={() => {
                form
                    .validateFields()
                    .then((values) => {                        
                        if (modalIsEditing === false) {
                            onCreate(values);
                            form.resetFields();
                        } else {
                            onUpdate(values)
                            form.resetFields();
                        }
                    })
                    .catch((info) => {console.log('Validate Failed:', info);});
            }}
            destroyOnClose
            forceRender={true} //important
        >
            <Form
                form={form}
                layout="horizontal"
                preserve={false}
            >
                <Form.Item
                    label="Grade"
                    name="grade"
                    rules={[
                        {
                            required: true,                                
                        },
                    ]}  
                >
                    <Select 
                        placeholder="--Please Select--" 
                        allowClear
                        disabled={gradeSelectDisabled}
                    >
                        {gradeDataSource.map(x => (
                            <Option key={x._id}>{`Grade ${x.grade}`}</Option>
                        ))}
                    </Select>
                </Form.Item>

                <Form.Item
                    label="Semester"
                    name="semester"
                    rules={[
                        {
                            required: true,                                
                        },
                    ]}  
                >
                    <Select 
                        placeholder="--Please Select--" 
                        allowClear
                        disabled={semesterSelectDisabled}
                    >
                        {semesterDataSource.map(x => (
                            <Option key={x._id}>{`Semester ${x.semester}`}</Option>
                        ))}
                    </Select>
                </Form.Item>

                <Form.Item
                    label="Title"
                    name="title"
                    rules={[
                        {
                            required: true,                                
                        },
                    ]}  
                >
                    <Input placeholder="Mathematics/Information Technology"/>
                </Form.Item>
            </Form>
        </Modal>
    );
};